import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Voucher } from '../models/voucher';
import { VoucherPerfil } from '../models/voucher-perfil';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
  ) { }

  salvar(voucher: Voucher) {
    return this.http.post(globals.apiUrl + '/api/Voucher/Salvar', voucher);
  }

  vincularCliente(idCliente: string, codigo: string) {
    return this.http.post(globals.apiUrl + '/api/Voucher/VincularCliente', { idCliente, codigo });
  }

  consultarGenericos() {
    return this.http.get<Voucher[]>(globals.apiUrl + '/api/Voucher/ListarGenericos');
  }

  consultarPorId(id: number) {
    return this.http.get<Voucher>(globals.apiUrl + '/api/Voucher/Buscar',
      {
        params: new HttpParams().set('id', id.toString())
      }
    );
  }

  consultarPerfis(idVoucher: number) {
    return this.http.get<VoucherPerfil[]>(globals.apiUrl + '/api/Voucher/BuscarPerfisExibicao',
      {
        params: new HttpParams().set('idVoucher', idVoucher.toString())
      }
    );
  }

  podeAplicarVouchers(idIntegrador: number) {
    return this.http.get<boolean>(globals.apiUrl + '/api/Voucher/PodeAplicarVouchers',
      {
        params: new HttpParams().set('idIntegrador', idIntegrador.toString())
      }
    );
  }

  consultarPorIdCliente(idCliente: string) {
    return this.http.get<Voucher[]>(globals.apiUrl + '/api/Voucher/ListarPorIdCliente', {
      params: new HttpParams().set('idCliente', idCliente)
    });
  }

  consutarPorCodigoVoucher(idCliente: string, codigo: string) {
    return this.http.get<Voucher[]>(globals.apiUrl + '/api/Voucher/BuscarPorCodigo', {
      params: new HttpParams()
        .set('idCliente', idCliente)
        .set('codigo', codigo)
    });
  }

  cancelar(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Voucher/CancelarVoucher',
      {
        params: new HttpParams().set('id', id.toString())
      }
    );
  }
}
